<script setup>
import Button from '@components/forms/Button.vue'

defineProps(['data'])
</script>

<template>
	<div class="overflow-hidden rounded-xl bg-black">
		<img class="w-full" :src="data.image" :alt="data.title" />
		<div class="relative flex items-center justify-center p-5 md:py-12">
			<div class="relative z-10 flex flex-col items-center justify-center gap-5 text-center text-white md:w-3/4">
				<h4>{{ data.title }}</h4>
				<p>{{ data.description }}</p>
				<Button class="primary solid swc hidden md:block" :to="data.cta_button_url">{{ data.cta_button_label }}</Button>
				<Button class="primary solid swc wide wide md:hidden" :to="data.cta_button_url">{{ data.cta_button_label }}</Button>
			</div>
			<img class="absolute -left-20 bottom-0 opacity-50 transition-opacity duration-300 md:left-0 xl:opacity-100" src="https://cdn.snkesports.com/events/images/elements/accents/shard-tr.svg" alt="Shard" />
			<img class="absolute -right-20 top-0 opacity-50 transition-opacity duration-300 md:right-0 xl:opacity-100" src="https://cdn.snkesports.com/events/images/elements/accents/shard-bl.svg" alt="Shard" />
		</div>
	</div>
</template>
